import { createSelector } from '@reduxjs/toolkit';

import { ArtistsState } from '@definitions/artists.types';

import { GlobalState } from '../createStore';

export const selectArtistsDomain = (state: GlobalState) => state.artists;

export const selectLayoutVariant = createSelector(selectArtistsDomain, (state: ArtistsState) => state.layoutVariant);
